export const FETCH_FULL_TRUCKLOADS_BROKERS = "FETCH_FULL_TRUCKLOADS_BROKERS"
export const DELETE_FULL_TRUCKLOADS_BROKER = "DELETE_FULL_TRUCKLOADS_BROKER"
export const SAVE_FULL_TRUCKLOADS_BROKERS = "SAVE_FULL_TRUCKLOADS_BROKERS"
export const STORE_FULL_TRUCKLOADS_BROKERS = "STORE_FULL_TRUCKLOADS_BROKERS"
export const STORE_FULL_TRUCKLOADS_BROKER = "STORE_FULL_TRUCKLOADS_BROKER"
